import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { Language } from 'app/shared/model/enums';
import { Subscription } from 'rxjs';
import { ReasonsUseUs } from '../declarations';

@Component({
  selector: 'app-reasons-for-using-our-product',
  templateUrl: './reasons-for-using-our-product.component.html',
  styleUrls: ['./reasons-for-using-our-product.component.scss']
})

export class ReasonsForUsingOurProductComponent implements OnInit {
  subscriptions = new Subscription();
  content: ReasonsUseUs;

  heStrings = {
    'reasonUseUs': "הפוך את העסק שלך לרווחי!",
    'reasonUseUs2': "מה זה Spin to Win?",
    'content_1':'אם אתם מחפשים דרך מהנה להגדיל באופן דרמטי את המכירות והרווחים שלכם, אז אל תחפשו עוד. הפרסום פשוט לא עובד כמו פעם, אז כדאי שתצמצמו את הוצאות הפרסום שלכם ותמצאו דרכים חדשות להלהיב ולשמח את הלקוחות שלכם. spinToWin היא אפליקציית חלוקת פרסים שיכולה לעזור לך ליצור קשר עם לקוחות פוטנציאליים ולגרום להם לחזור לעוד. הם יופתעו ויתרגשו להתחבר לעסק שלכם, ואתם תשמחו מהתוצאות.',
    'content_2': "ספין טו ווין היא פלטפורמה חדשנית לבניית מועדון לקוחות דיגיטלי. הוא מספק לעסקים כלי מרתק וידידותי למשתמש לאיסוף פרטי לקוחות. באמצעות מנגנון הרולטה הייחודי, הלקוחות משתתפים במשחק עם הזדמנות לזכות בתגמולים והטבות מיידיות, בעוד עסקים נהנים ממאגר לקוחות פעיל ויעיל.",
  }
/*
    'reasonUseUs2': "Spin the Wheel to Win New Customers!",
    'content_2': "We have already seen great results from our exciting sales and loyalty incentives system among businesses across the U.S. ‘Spin to Win’ offers a new way to distribute prizes, create high levels of positive engagement, and increase sales.\n Our prize wheel platform is simple and very effective. You can customize it quickly and easily, and generate great results for your business at minimal cost.\n Try it today for FREE!"

*/
  enStrings = {
    'reasonUseUs': "Spin your Business into Profit!",
    'reasonUseUs2': "What is Spin to Win?",
    'content_1': "If you are looking for a fun way to dramatically increase your sales and profits, then look no further. Advertising just isn’t working like it used to, so you might as well cut your ad spend and find new ways to excite and delight your customers.\n ‘Spin to Win’ is a prize giveaway app that can help you engage with potential customers and keep them coming back for more. They will be surprised and excited to connect with your business, and you will be delighted with the results.",
    'content_2': "Spin to Win is an innovative platform for building a digital customer club. It provides businesses with an engaging, user-friendly tool to collect customer details.\n Using the unique roulette mechanism, customers participate in a game with the chance to win instant rewards and perks, while businesses benefit from an active and effective customer database."
  }
  
  constructor(store: Store<AppState>) {
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe((language: Language) => {
      this.loadData(language);
    }));
  }

  ngOnInit(): void {
  }

  loadData(language: Language) {
    switch (language) {
      case Language.he:
        this.content = this.heStrings;
        break;
      default:
        this.content = this.enStrings
        break;
    }

  }
}
